import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlatformAesService {
  private passphrase = environment.cipheringPhrase;

  private keySize = 128 / 32;
  private iterationCount = 1000;

  constructor() { }

  decrypt(salt, iv, cipheredText, keySize = this.keySize, iterationCount = this.iterationCount) {
    const key = CryptoJS.PBKDF2(this.passphrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipheredText)
    });
    const decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        key,
        {iv: CryptoJS.enc.Hex.parse(iv)});
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedString.toString();
  }

  encrypt(plainText: string) {
    const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    const encryptedText = this.aesEncrypt(salt, iv, this.passphrase, plainText);
    return {
      salt: salt,
      iv: iv,
      cipheredText: encryptedText
    };
  }

  private aesEncrypt(salt, iv, passPhrase, plainText, keySize  = this.keySize, iterationCount = this.iterationCount) {
    const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
    const encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        {iv: CryptoJS.enc.Hex.parse(iv)});
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }
}
